
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      scoreTypes: [
        // NOTE: labels are based off fixture.state.sourceName
        { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
        { state: `FullTimePens`, label: `Full-Time`, field: `fullTimeScore` },
        { state: `FullTime90`, label: `Full-Time`, field: `fullTimeScore` },
      ],
      availableScoreTypes: [],
    };
  },
  watch: {
    'fixture.state.sourceName': {
      handler () {
        this.checkAvailableScoreTypes();
      },
    },
  },
  mounted () {
    this.checkAvailableScoreTypes();
  },
  methods: {
    checkAvailableScoreTypes () {
      if (this.isFixtureLive(this.fixture)) {
        this.scoreTypes = this.filterScoreTypesOnState();
      } else {
        this.scoreTypes = this.filterScoreTypesOnWinType();
      }
      if (this.scoreTypes) {
        this.availableScoreTypes = this.scoreTypes.filter(scoreType => {
          if (typeof this.fixture?.fixtureTeams[0][scoreType.field] === `string`) return scoreType;
        });
      }
    },
    filterScoreTypesOnState () {
      const stateOrder = this.fixture?.state.order;
      if (stateOrder < 200) {
        return [];
      }
      if (stateOrder > 200 && stateOrder <= 400) {
        return [{ state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` }];
      }
      if (stateOrder > 400 && stateOrder < 800) {
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
          { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
        ];
      }
      if (stateOrder >= 800 && stateOrder < 900) {
        if (this.hasMatchGoneToExtraTime(this.fixture)) {
          return [
            { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
            { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
            { state: `FullTime`, label: `Extra-Time`, field: `extraTimeScore` },
            { state: `FullTime`, label: `Penatly-Score`, field: `penaltyScore` },
          ];
        }
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
          { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
          { state: `FullTime`, label: `Penatly-Score`, field: `penaltyScore` },
        ];
      }
    },
    filterScoreTypesOnWinType () {
      switch (this.fixture.winType?.name) {
      case `NormalResult`:
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
        ];
      case `AfterExtraTime`:
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
          { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
        ];

      case `PenaltyShootout` || `ShootOut`:
        if (this.hasMatchGoneToExtraTime(this.fixture)) {
          return [
            { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
            { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
            { state: `FullTime`, label: `Extra-Time`, field: `extraTimeScore` },
            { state: `FullTime`, label: `Penatly-Score`, field: `penaltyScore` },
          ];
        }
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
          { state: `FullTime`, label: `Full-Time`, field: `fullTimeScore` },
          { state: `FullTime`, label: `Penatly-Score`, field: `penaltyScore` },
        ];

      default:
        return [
          { state: `FullTime`, label: `Half-Time`, field: `halfTimeScore` },
        ];
      }
    },
  },
};
